import React from "react"
import { Button } from "antd"
import { useHistory } from "react-router-dom"
import { useNotes } from "./use-notes"
import { ManualReferToggle } from "components/ManualReferToggle"
import { QuoteActionsProps } from "."
import { getEmbargoBindState } from "./embargo-bind"

export const QuoteActionsDU: React.FC<QuoteActionsProps> = (props) => {
  const history = useHistory()

  const { bindDisabled, embargoBindAlert } = getEmbargoBindState(props)

  const { noteModal, showNoteModal } = useNotes(
    props.quoteId,
    props.quoteLifecycles?.onAddNote
  )

  const bindQuote = () => {
    if (bindDisabled === true) return

    history.push(`/opus/checkout/${props.quoteId}`, {
      proposerEmail: props.proposerEmail
    })
  }

  switch (props.quoteState) {
    case "Referred":
      return (
        <>
          {props.isBrokerProduct !== true && (
            <ManualReferToggle
              onManualReferral={() => props.handleManualReferral?.()}
              onRevokeManualReferral={() =>
                props.handleRevokeManualReferral?.()
              }
              quoteActions={props.quoteActions}
              isLoading={props.isManualReferralLoading}
            />
          )}

          {props.renderQuoteDocuments}

          <Button onClick={() => showNoteModal(true)}>Add note</Button>

          {noteModal}
        </>
      )

    case "Purchased":
      return (
        <>
          {props.renderQuoteDocuments}

          <Button onClick={() => showNoteModal(true)}>Add note</Button>

          {noteModal}
        </>
      )

    case "Withdrawn":
      return null

    case "Open":
      return null

    case "Expired":
      return null

    case "PendingPayment":
      return (
        <>
          {props.renderQuoteDocuments}

          <Button onClick={() => showNoteModal(true)}>Add note</Button>

          {noteModal}

          {(props.configuration.flags?.paymentType === "SymphonyCheckout" ||
            props.configuration.flags?.paymentTypes?.includes(
              "SymphonyCheckout"
            )) && (
            <>
              {embargoBindAlert}
              <Button
                type="primary"
                onClick={bindQuote}
                disabled={bindDisabled}
              >
                Bind
              </Button>
            </>
          )}

          {props.isBrokerProduct !== true && (
            <ManualReferToggle
              onManualReferral={() => props.handleManualReferral?.()}
              onRevokeManualReferral={() =>
                props.handleRevokeManualReferral?.()
              }
              quoteActions={props.quoteActions}
              isLoading={props.isManualReferralLoading}
            />
          )}
        </>
      )
    case "Quoted":
      return (
        <>
          {props.isBrokerProduct !== true && (
            <ManualReferToggle
              onManualReferral={() => props.handleManualReferral?.()}
              onRevokeManualReferral={() =>
                props.handleRevokeManualReferral?.()
              }
              quoteActions={props.quoteActions}
              isLoading={props.isManualReferralLoading}
            />
          )}

          {props.renderQuoteDocuments}

          <Button onClick={() => showNoteModal(true)}>Add note</Button>

          {noteModal}

          {(props.configuration.flags.paymentType === "SymphonyCheckout" ||
            props.configuration.flags?.paymentTypes?.includes(
              "SymphonyCheckout"
            )) && (
            <>
              {embargoBindAlert}
              <Button
                type="primary"
                onClick={bindQuote}
                disabled={bindDisabled}
              >
                Bind
              </Button>
            </>
          )}

          {/* {(props.configuration.flags.paymentType === "PayOnAccount" ||
            props.configuration.flags?.paymentTypes?.includes(
              "PayOnAccount"
            )) &&
            props.policyDetail &&
            policyDetailHasPremium(props.policyDetail) && (
              <QuoteBindWithConfirmation
                quoteReferenceID={props.quoteReferenceID}
                onBindQuote={props.handleBindQuote}
                quotePaymentPlans={props.paymentPlans}
                proposer={props.proposer}
                quoteCompanies={props.quoteCompanies}
                platformVersion={props.configuration.flags.platformVersion}
                blockBind={bindDisabled}
                quoteChanges={props.quoteChanges}
                coverEndDate={props.coverEndDate}
                coverStartDate={props.coverStartDate}
              />
            )} */}
        </>
      )
    default:
      return null
  }
}
